import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import './CircleInput.sass'
import icons from "../../../assets/icons";

CircleInput.propTypes = {
    placeHolder: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func
};

function CircleInput(props) {

    const myRef = useRef();
    useEffect(() => {
        try {
            if (!props?.value[props.name]) {
                myRef.current.value = ''
            }
        }
        catch (e) {

        }

    }, [props.value])

    return (
        <div className={'circleInput'}>
            <input ref={myRef}
                   onKeyPress={props.onKeyPress}
                   name={props.name}
                   id={props.name}
                   onChange={e => props.onChange(e)}
                   placeholder={props.placeHolder}
                   type="text"/>

            <img src={icons.search} alt="d"/>
        </div>
    );
}

export default CircleInput;